<template>
  <div
    class="loader-wrapper"
    :class="{
      stretched: stretch,
      inverse: inverse,
    }"
  >
    <div class="loader"></div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  stretch: Boolean,
  inverse: Boolean,
});

defineExpose({
  props,
});
</script>

<style lang="scss" scoped>
.loader-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow: hidden;

  &.stretched {
    height: 100vh;
    width: 100vw;
    position: static;
  }
  &.inverse {
    background: none;
  }

  .loader {
    &::after {
      content: "";
      position: absolute;
      width: 75px;
      height: 75px;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      border: 10px solid rgb(239, 239, 239);
      border-top-color: var(--theme-color);
      border-radius: 50%;
      animation: button-loading-spinner 1s ease infinite;
    }
  }
}

@keyframes button-loading-spinner {
  from {
    transform: rotate(0turn);
  }

  to {
    transform: rotate(1turn);
  }
}
</style>
